import { t } from '@lingui/core/macro';
import { ButtonGroup } from '@pocketlaw/tetris';
import { DateRange } from './DateRange';
import { RelativeDate } from './RelativeDate';
import { withFilterErrorBoundary } from '../FilterErrorBoundary';
import { ClearFilter } from '../components/ClearFilter';
import { NullOperator } from '../components/NullOperator';
import { OperatorSelector } from '../components/OperatorSelector';
import { useFilter } from '../useFilter';
export const DateRangeFilter = withFilterErrorBoundary((props) => {
    const { name, label } = props;
    const filter = useFilter(name);
    return (<ButtonGroup>
      <OperatorSelector name={name} label={label} operators={[
            {
                id: 'gte',
                menuItem: t({ message: 'Date range', comment: 'Filter: Date range filter selection' }),
                onSelect: () => filter.applyValue({ gte: undefined, lte: undefined }),
            },
            {
                id: 'rgte',
                menuItem: t({
                    message: 'Relative date',
                    comment: 'Filter: Relative date filter selection',
                }),
                onSelect: () => filter.applyValue({ rgte: undefined }),
            },
            {
                id: 'isNull',
                menuItem: t({
                    message: 'Has value',
                    comment: 'Filter: Has value filter selection',
                }),
                onSelect: () => filter.applyValue({ isNull: undefined }),
            },
        ]}/>
      {(filter.operator === 'gte' || filter.operator === 'lte') && <DateRange name={name}/>}

      {(filter.operator === 'rgte' || filter.operator === 'rlte') && <RelativeDate name={name}/>}

      {filter.operator === 'isNull' && <NullOperator name={name}/>}

      <ClearFilter name={name}/>
    </ButtonGroup>);
});
